import { render, staticRenderFns } from "./CategoryLocation.vue?vue&type=template&id=4e8a3f15&scoped=true"
import script from "./CategoryLocation.vue?vue&type=script&lang=js"
export * from "./CategoryLocation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e8a3f15",
  null
  
)

export default component.exports